var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-btn',{staticClass:"gamayun-button align-self-center text-none",attrs:{"data-cy":"gamayun-button","text":""},on:{"click":_vm.openGamayun}},[_vm._v(" Гамаюн ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }